import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "long-night",
    title: "长夜将尽",
    originalTitle: "The Long Night Ends",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20art%2C%20lone%20silhouette%20walking%20through%20a%20rainy%20neon%20alley%20at%20night%2C%20moody%20low%20key%20lighting%2C%20warm%20amber%20highlights%2C%20film%20grain%20texture%2C%20dramatic%20atmosphere%2C%20high%20detail&width=600&height=900&seq=yp-poster-01&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rain%20drenched%20neon%20city%20street%20at%20night%2C%20a%20lone%20figure%20in%20a%20long%20coat%20standing%20under%20glowing%20signs%2C%20moody%20atmospheric%20lighting%2C%20teal%20and%20amber%20tones%2C%20film%20still%2C%20dramatic%20depth&width=1600&height=900&seq=yp-cover-01&orientation=landscape",
    year: 2026,
    rating: 8.7,
    genres: ["action", "thriller"],
    director: "陈兆铭",
    cast: ["赵寒声", "林鹿", "周正刚", "苏禾"],
    duration: 138,
    releaseDate: "2026-03-14",
    region: "中国大陆",
    heat: 9860,
    summary: "一名隐退多年的卧底被迫重返江湖，在一夜之间揭开潜伏十年的惊天秘密。",
    synopsis:
      "十年前，缉毒警程野以失败告终的任务让他背负骂名黯然离场。如今，昔日搭档的离奇身亡迫使他重返这座不夜城。随着线索层层剥开，他发现真正的敌人一直藏在身边。长夜将尽，黎明之前，他必须做出最后的选择。",
    tags: ["卧底", "犯罪", "硬核动作", "高口碑"],
  },
  {
    id: "mountain-dream",
    title: "山河故梦",
    originalTitle: "Dreams of Rivers and Mountains",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20art%2C%20elderly%20figure%20standing%20on%20a%20misty%20mountain%20ridge%20at%20dawn%2C%20soft%20golden%20backlight%2C%20melancholic%20mood%2C%20painterly%20composition%2C%20film%20grain%2C%20earthy%20warm%20tones&width=600&height=900&seq=yp-poster-02&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Sweeping%20cinematic%20landscape%20of%20misty%20mountains%20and%20a%20winding%20river%20valley%20at%20golden%20hour%2C%20tiny%20village%20nestled%20in%20the%20hills%2C%20warm%20amber%20light%2C%20atmospheric%20haze%2C%20epic%20film%20still&width=1600&height=900&seq=yp-cover-02&orientation=landscape",
    year: 2025,
    rating: 8.4,
    genres: ["drama"],
    director: "沈砚秋",
    cast: ["王立群", "何蔓", "张致远"],
    duration: 126,
    releaseDate: "2025-11-08",
    region: "中国大陆",
    heat: 7420,
    summary: "三代人跨越四十年守护同一片山林，写就一段关于故土与传承的深情史诗。",
    synopsis:
      "从计划经济年代到乡村振兴的今天，守林人一家三代在群山之间坚守。父亲的执拗、儿子的远行、孙辈的归来，构成一幅跨越四十年的时代画卷。影片以细腻笔触描摹普通人与土地的羁绊。",
    tags: ["年代", "家庭", "现实题材", "催泪"],
  },
  {
    id: "star-echo",
    title: "星际回响",
    originalTitle: "Echoes of the Stars",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20art%2C%20astronaut%20helmet%20reflecting%20a%20giant%20distant%20planet%2C%20deep%20space%20nebula%2C%20cold%20blue%20grey%20with%20warm%20gold%20rim%20light%2C%20minimal%20futuristic%20composition%2C%20high%20detail&width=600&height=900&seq=yp-poster-03&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20lone%20spaceship%20drifting%20toward%20a%20vast%20ringed%20planet%2C%20swirling%20nebula%20clouds%2C%20deep%20indigo%20void%20with%20warm%20golden%20starlight%2C%20majestic%20scale%2C%20film%20still%20quality&width=1600&height=900&seq=yp-cover-03&orientation=landscape",
    year: 2026,
    rating: 8.9,
    genres: ["scifi", "drama"],
    director: "顾星河",
    cast: ["江叙白", "桑妮·洛", "郑亦辰"],
    duration: 148,
    releaseDate: "2026-01-22",
    region: "中国大陆 / 国际合作",
    heat: 11240,
    summary: "一次跨越光年的回信任务，让人类在宇宙尽头听见了来自过去的声音。",
    synopsis:
      "人类首艘深空探索船在抵达目标星系后失联。二十年后，地面指挥中心收到了一段来自船长妻子的加密讯号——它本该在十年前就已发出。为了解开时间悖论之谜，一名年轻物理学家踏上了追寻真相的孤独航程。",
    tags: ["太空", "时间悖论", "视效大片", "年度期待"],
  },
  {
    id: "laugh-life",
    title: "笑闹人生",
    originalTitle: "A Laughable Life",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%2C%20cheerful%20middle%20aged%20man%20with%20a%20red%20bicycle%20surrounded%20by%20colorful%20props%2C%20bright%20warm%20playful%20lighting%2C%20yellow%20background%2C%20joyful%20energetic%20mood&width=600&height=900&seq=yp-poster-04&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20playful%20cinematic%20street%20scene%20of%20a%20quirky%20man%20riding%20a%20red%20bicycle%20through%20a%20sunny%20town%2C%20vivid%20warm%20colors%2C%20joyful%20energy%2C%20comedic%20film%20still&width=1600&height=900&seq=yp-cover-04&orientation=landscape",
    year: 2025,
    rating: 7.9,
    genres: ["comedy"],
    director: "钱多多",
    cast: ["牛大伟", "文慧", "李好笑"],
    duration: 112,
    releaseDate: "2025-12-19",
    region: "中国大陆",
    heat: 6880,
    summary: "一个中年失业大叔的荒诞再就业之路，笑到最后的竟是他自己。",
    synopsis:
      "四十五岁的老牛被公司裁员，为了不让家人发现，他每天假装上班，却在城市的角落里闹出一连串啼笑皆非的乌龙。当谎言越滚越大，他终于明白：人生下半场，认真搞笑也是一种本事。",
    tags: ["家庭喜剧", "中年危机", "解压"],
  },
  {
    id: "spring-letter",
    title: "春日来信",
    originalTitle: "Letter from Spring",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20art%2C%20young%20woman%20holding%20a%20paper%20letter%20under%20blooming%20cherry%20blossoms%2C%20soft%20pastel%20spring%20light%2C%20warm%20pink%20and%20cream%20palette%2C%20tender%20nostalgic%20mood&width=600&height=900&seq=yp-poster-05&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20scene%20of%20cherry%20blossom%20petals%20falling%20over%20a%20quiet%20old%20street%2C%20a%20couple%20walking%20apart%20under%20soft%20spring%20sunlight%2C%20warm%20pastel%20tones%2C%20romantic%20film%20still&width=1600&height=900&seq=yp-cover-05&orientation=landscape",
    year: 2026,
    rating: 8.1,
    genres: ["romance"],
    director: "温柔",
    cast: ["许知夏", "陆行舟", "白鹿"],
    duration: 118,
    releaseDate: "2026-04-02",
    region: "中国大陆",
    heat: 7210,
    summary: "两封错投十年的信，牵起一段被春天重新书写的爱情。",
    synopsis:
      "整理旧居时，插画师夏栀意外发现一叠从未寄出的情书。循着信中地址，她找到了已经搬离多年的收信人。随着书信背后故事的揭开，两个素未谋面的人，在春天里重新学会了如何勇敢去爱。",
    tags: ["治愈", "书信", "青春"],
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    originalTitle: "Silent Testimony",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%20art%2C%20close%20up%20of%20a%20womans%20face%20half%20in%20shadow%20with%20a%20witness%20stand%20in%20blurred%20background%2C%20cold%20desaturated%20tones%20with%20a%20single%20warm%20light%2C%20tense%20mood%2C%20film%20noir&width=600&height=900&seq=yp-poster-06&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20courtroom%20scene%20in%20near%20darkness%2C%20shafts%20of%20light%20falling%20through%20tall%20windows%2C%20a%20lone%20figure%20at%20the%20dock%2C%20cold%20grey%20palette%20with%20amber%20accent%20light%2C%20suspenseful%20film%20still&width=1600&height=900&seq=yp-cover-06&orientation=landscape",
    year: 2025,
    rating: 8.6,
    genres: ["thriller", "drama"],
    director: "陆慎",
    cast: ["韩雪落", "傅明川", "周语"]
    ,
    duration: 132,
    releaseDate: "2025-10-17",
    region: "中国大陆",
    heat: 8340,
    summary: "一场没有目击者的谋杀案，唯一的证人是个说不出话的孩子。",
    synopsis:
      "知名律师接手一桩看似证据确凿的凶杀案。唯一的目击者是位患有选择性缄默症的九岁女孩。为了让她开口，律师必须重新面对自己尘封多年的创伤，而真相远比他想象的更加残酷。",
    tags: ["法庭", "反转", "心理"],
  },
  {
    id: "dragon-ridge",
    title: "龙脊行动",
    originalTitle: "Operation Dragon Ridge",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20war%20action%20movie%20poster%20art%2C%20squad%20of%20soldiers%20silhouetted%20against%20a%20fiery%20sunset%20on%20a%20jagged%20mountain%20ridge%2C%20explosions%20and%20smoke%2C%20dramatic%20orange%20and%20charcoal%20tones%2C%20heroic%20mood&width=600&height=900&seq=yp-poster-07&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20battlefield%20panorama%20of%20soldiers%20advancing%20across%20a%20mountain%20ridge%20at%20dusk%2C%20helicopters%20and%20smoke%20plumes%2C%20dramatic%20orange%20sky%2C%20gritty%20war%20film%20still&width=1600&height=900&seq=yp-cover-07&orientation=landscape",
    year: 2026,
    rating: 8.3,
    genres: ["action"],
    director: "岳峰",
    cast: ["秦烈", "赵刚", "何塞·罗"],
    duration: 144,
    releaseDate: "2026-02-06",
    region: "中国大陆",
    heat: 9120,
    summary: "八人小队深入敌后执行绝密任务，用血肉之躯守住最后的防线。",
    synopsis:
      "边境局势骤然升级，一支由各兵种精英组成的突击小队奉命摧毁敌方通讯枢纽。在失去支援的孤境中，他们必须在二十四小时内完成不可能的任务，而彼此之间的信任成为唯一的武器。",
    tags: ["战争", "团队", "大场面"],
  },
  {
    id: "phantom-sea",
    title: "幻海浮生",
    originalTitle: "The Floating Sea",
    poster:
      "https://readdy.ai/api/search-image?query=Surreal%20cinematic%20sci%20fi%20movie%20poster%20art%2C%20a%20person%20floating%20above%20a%20mirror%20like%20ocean%20reflecting%20a%20giant%20floating%20city%2C%20dreamlike%20atmosphere%2C%20teal%20and%20warm%20gold%20contrast%2C%20ethereal%20beauty&width=600&height=900&seq=yp-poster-08&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20cinematic%20vista%20of%20a%20floating%20futuristic%20city%20above%20an%20endless%20mirror%20ocean%20at%20sunset%2C%20reflections%20and%20haze%2C%20dreamlike%20scale%2C%20teal%20and%20amber%20palette%2C%20art%20film%20still&width=1600&height=900&seq=yp-cover-08&orientation=landscape",
    year: 2025,
    rating: 8.0,
    genres: ["scifi", "drama"],
    director: "顾星河",
    cast: ["江叙白", "温雨眠"],
    duration: 130,
    releaseDate: "2025-09-26",
    region: "中国大陆",
    heat: 6540,
    summary: "在被海水淹没的未来世界，人类把记忆存进云端，却遗失了真实的自己。",
    synopsis:
      "海平面上升后，幸存者居住在漂浮城市里，靠出售记忆维持生存。记忆修复师林昼在一次委托中，发现一段不属于任何人的记忆。追寻之下，他触及了这个乌托邦制度最深的谎言。",
    tags: ["未来世界", "记忆", "文艺科幻"],
  },
  {
    id: "city-glow",
    title: "都市浮光",
    originalTitle: "City Glow",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20movie%20poster%20art%2C%20young%20office%20worker%20standing%20at%20a%20rainy%20window%20overlooking%20a%20night%20city%2C%20reflected%20lights%2C%20moody%20amber%20and%20grey%20tones%2C%20introspective%20mood&width=600&height=900&seq=yp-poster-09&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20panorama%20of%20a%20modern%20city%20skyline%20seen%20through%20rain%20streaked%20glass%2C%20warm%20window%20lights%2C%20cool%20grey%20atmosphere%2C%20urban%20drama%20film%20still&width=1600&height=900&seq=yp-cover-09&orientation=landscape",
    year: 2026,
    rating: 7.8,
    genres: ["drama"],
    director: "许蔚然",
    cast: ["陈默", "顾一诺", "罗晓"]
    ,
    duration: 120,
    releaseDate: "2026-03-01",
    region: "中国大陆",
    heat: 5980,
    summary: "三个在大城市打拼的年轻人，在霓虹与疲惫之间寻找属于自己的光。",
    synopsis:
      "合租在同一屋檐下的三个年轻人，分别带着不同的梦想来到这座城市。生活的压力、感情的取舍与理想的拉扯，让他们的友谊经历考验。浮光掠影的都市里，他们学着与自己和解。",
    tags: ["都市", "群像", "现实"],
  },
  {
    id: "crazy-holiday",
    title: "疯狂假期",
    originalTitle: "Crazy Holiday",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%2C%20a%20chaotic%20family%20with%20luggage%20chasing%20a%20departing%20bus%20at%20a%20sunny%20resort%2C%20bright%20vivid%20warm%20colors%2C%20energetic%20funny%20mood&width=600&height=900&seq=yp-poster-10&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20sunny%20cinematic%20beach%20resort%20scene%20with%20a%20hilarious%20family%20vacation%20chaos%2C%20colorful%20umbrellas%2C%20vivid%20warm%20tropical%20colors%2C%20joyful%20comedy%20film%20still&width=1600&height=900&seq=yp-cover-10&orientation=landscape",
    year: 2025,
    rating: 7.6,
    genres: ["comedy"],
    director: "钱多多",
    cast: ["牛大伟", "吴姐", "凯文·李"]
    ,
    duration: 105,
    releaseDate: "2025-12-24",
    region: "中国大陆",
    heat: 6120,
    summary: "一家五口说走就走的旅行，从第一天起就彻底失控。",
    synopsis:
      "为了修复濒临破裂的家庭关系，爸爸决定带全家去海岛度假。没想到机票订错、行李拿混、导游跑路，一连串意外让这趟旅程变成大型灾难现场。可正是在狼狈之中，他们重新找回了彼此。",
    tags: ["合家欢", "旅行", "爆笑"],
  },
  {
    id: "moonlight-city",
    title: "月光之城",
    originalTitle: "Moonlight City",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20art%2C%20a%20couple%20dancing%20silhouette%20on%20a%20rooftop%20under%20a%20huge%20moon%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20dreamy%20nostalgic%20mood&width=600&height=900&seq=yp-poster-11&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20cinematic%20cityscape%20at%20night%20under%20a%20giant%20glowing%20moon%2C%20warm%20street%20lamps%20lining%20an%20empty%20avenue%2C%20dreamy%20amber%20and%20deep%20blue%20palette%2C%20film%20still&width=1600&height=900&seq=yp-cover-11&orientation=landscape",
    year: 2026,
    rating: 8.2,
    genres: ["romance", "drama"],
    director: "温柔",
    cast: ["沈月白", "顾时安", "许知夏"]
    ,
    duration: 122,
    releaseDate: "2026-05-20",
    region: "中国大陆",
    heat: 7640,
    summary: "每逢满月才会出现的旧唱片店，藏着一对恋人未完待续的故事。",
    synopsis:
      "电台主持人苏晚在一次夜晚散步中，走进了一家只在满月夜营业的唱片店。店主是一位沉默的年轻混音师。随着一首首老歌被播放，两人发现彼此的生命早已在多年前的那个夏天交错过。",
    tags: ["都市爱情", "音乐", "复古"],
  },
  {
    id: "dark-current",
    title: "暗流迷局",
    originalTitle: "Undercurrent",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%20art%2C%20a%20detective%20with%20a%20flashlight%20illuminating%20a%20shadowy%20warehouse%2C%20swirling%20dust%2C%20cold%20grey%20green%20tones%20with%20a%20warm%20beam%2C%20tense%20mystery%20mood&width=600&height=900&seq=yp-poster-12&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20scene%20of%20a%20shadowy%20harbor%20at%20night%20with%20containers%20and%20fog%2C%20a%20lone%20silhouette%20with%20a%20flashlight%2C%20cold%20grey%20green%20tone%2C%20suspenseful%20film%20still&width=1600&height=900&seq=yp-cover-12&orientation=landscape",
    year: 2025,
    rating: 8.5,
    genres: ["thriller"],
    director: "陆慎",
    cast: ["傅明川", "韩雪落", "江铭"]
    ,
    duration: 128,
    releaseDate: "2025-11-21",
    region: "中国大陆",
    heat: 8020,
    summary: "一具江边浮尸，牵出一张盘踞城市二十年的隐秘之网。",
    synopsis:
      "老刑警在退休前接到最后一案：江边发现无名浮尸。随着调查深入，案件与二十年前的一桩悬案逐渐重叠。真相隐藏在城市的暗流之下，而查得越深，他越发现自己也是网中之人。",
    tags: ["刑侦", "多线叙事", "烧脑"],
  },
  {
    id: "iron-dawn",
    title: "铁血黎明",
    originalTitle: "Iron Dawn",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20art%2C%20a%20gritty%20fighter%20with%20bandaged%20hands%20in%20an%20underground%20arena%2C%20harsh%20rim%20lighting%2C%20sweat%20and%20smoke%2C%20orange%20and%20charcoal%20tones%2C%20intense%20mood&width=600&height=900&seq=yp-poster-13&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20cinematic%20underground%20fight%20club%20scene%20with%20a%20crowd%20in%20shadows%2C%20single%20ring%20under%20harsh%20light%2C%20smoke%20and%20dust%2C%20orange%20and%20charcoal%20palette%2C%20raw%20film%20still&width=1600&height=900&seq=yp-cover-13&orientation=landscape",
    year: 2026,
    rating: 8.0,
    genres: ["action", "drama"],
    director: "岳峰",
    cast: ["秦烈", "关山月", "林鹿"]
    ,
    duration: 135,
    releaseDate: "2026-06-12",
    region: "中国大陆",
    heat: 7760,
    summary: "前拳王为救女儿重返地下擂台，用最后一拳打碎命运的枷锁。",
    synopsis:
      "曾经的拳坛之星因伤退隐，如今靠在工地搬砖养活女儿。当女儿重病急需手术费时，他被迫重返那个充满暴力的地下世界。铁血的赛场上，他打的每一场都不只是为了钱，更是为了尊严与亲情。",
    tags: ["格斗", "父女", "热血"],
  },
  {
    id: "time-fold",
    title: "时间褶皱",
    originalTitle: "The Fold of Time",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20art%2C%20a%20person%20standing%20before%20a%20fractured%20mirror%20reflecting%20multiple%20versions%20of%20themselves%2C%20conceptual%20geometry%2C%20cold%20grey%20with%20warm%20gold%20seams%2C%20minimal%20high%20detail&width=600&height=900&seq=yp-poster-14&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20scene%20of%20a%20fractured%20reality%20where%20city%20streets%20fold%20into%20each%20other%20like%20a%20mirror%20maze%2C%20concept%20sci%20fi%2C%20cold%20grey%20with%20warm%20gold%20light%20seams%2C%20surreal%20film%20still&width=1600&height=900&seq=yp-cover-14&orientation=landscape",
    year: 2025,
    rating: 8.4,
    genres: ["scifi", "thriller"],
    director: "顾星河",
    cast: ["郑亦辰", "温雨眠", "桑妮·洛"]
    ,
    duration: 140,
    releaseDate: "2025-08-15",
    region: "中国大陆",
    heat: 8460,
    summary: "一次实验事故让时间出现褶皱，同一个人在不同时间线里相遇。",
    synopsis:
      "物理学家在一次高能实验中意外制造出时间褶皱，城市的某个街角成了不同时间线的交汇点。为了挽救一场本已发生的悲剧，他一次次穿越褶皱，却发现每改变一次，代价都比想象中更沉重。",
    tags: ["时间旅行", "硬科幻", "概念"],
  },
  {
    id: "mother-stitch",
    title: "母亲的针脚",
    originalTitle: "A Mother's Stitch",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20movie%20poster%20art%2C%20an%20elderly%20mother%20sewing%20by%20a%20warm%20window%20at%20dusk%2C%20soft%20golden%20light%2C%20tender%20nostalgic%20mood%2C%20warm%20earthy%20tones%2C%20film%20grain&width=600&height=900&seq=yp-poster-15&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20of%20an%20old%20sunlit%20room%20with%20a%20sewing%20machine%20and%20a%20mother%20by%20the%20window%2C%20dust%20motes%20in%20golden%20light%2C%20intimate%20nostalgic%20film%20still&width=1600&height=900&seq=yp-cover-15&orientation=landscape",
    year: 2026,
    rating: 8.8,
    genres: ["drama"],
    director: "沈砚秋",
    cast: ["何蔓", "王立群", "白鹿"]
    ,
    duration: 116,
    releaseDate: "2026-05-08",
    region: "中国大陆",
    heat: 8240,
    summary: "一件缝缝补补的旧棉袄，缝住了一位母亲一辈子的心事。",
    synopsis:
      "母亲一生节俭，把所有的爱都缝进了子女的衣服里。当女儿偶然整理旧物，发现棉袄夹层中藏着的字条与存折，一段被岁月掩埋的母爱往事缓缓浮现。影片用最朴素的针脚，缝出最深的牵挂。",
    tags: ["母亲", "亲情", "催泪"],
  },
  {
    id: "comedy-king",
    title: "喜剧之王归来",
    originalTitle: "The Comedy King Returns",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20drama%20movie%20poster%20art%2C%20a%20washed%20up%20comedian%20on%20a%20small%20stage%20with%20a%20single%20spotlight%2C%20warm%20amber%20light%20against%20dark%20theater%2C%20bittersweet%20mood&width=600&height=900&seq=yp-poster-16&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20empty%20old%20theater%20stage%20with%20a%20single%20spotlight%20and%20a%20lone%20microphone%2C%20warm%20amber%20glow%20in%20the%20darkness%2C%20bittersweet%20mood%2C%20film%20still&width=1600&height=900&seq=yp-cover-16&orientation=landscape",
    year: 2025,
    rating: 8.3,
    genres: ["comedy", "drama"],
    director: "钱多多",
    cast: ["牛大伟", "文慧", "罗晓"]
    ,
    duration: 124,
    releaseDate: "2025-10-31",
    region: "中国大陆",
    heat: 7020,
    summary: "过气笑星为保住即将拆迁的小剧场，决定办一场最后的演出。",
    synopsis:
      "曾经红极一时的喜剧演员如今无人问津，只剩下一间快要拆迁的小剧场。为了留住梦想的舞台，他召集昔日搭档，办一场注定赔本的最后演出。笑声背后，是一代喜剧人对舞台的深情告别。",
    tags: ["喜剧人生", "励志", "温情"],
  },
  {
    id: "snowfall-silent",
    title: "雪落无声",
    originalTitle: "Silent Snowfall",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20art%2C%20two%20figures%20standing%20apart%20in%20a%20quiet%20snowy%20village%20street%2C%20soft%20blue%20grey%20light%20with%20warm%20lantern%20glow%2C%20melancholic%20tender%20mood&width=600&height=900&seq=yp-poster-17&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20cinematic%20snowy%20northern%20village%20at%20dusk%2C%20falling%20snow%20and%20warm%20window%20lights%2C%20quiet%20winter%20atmosphere%2C%20soft%20blue%20grey%20with%20amber%20accents%2C%20film%20still&width=1600&height=900&seq=yp-cover-17&orientation=landscape",
    year: 2025,
    rating: 7.9,
    genres: ["romance", "drama"],
    director: "温柔",
    cast: ["沈月白", "陆行舟"]
    ,
    duration: 110,
    releaseDate: "2025-12-12",
    region: "中国大陆",
    heat: 5940,
    summary: "十年后重回初雪的故乡，她与当年那个少年再次相遇。",
    synopsis:
      "设计师叶知秋因为工作回到阔别十年的北方小城。初雪落下时，她在老书店里遇见了当年不告而别的初恋。面对彼此的改变与未说出口的歉意，他们决定给这场相遇一个真正的结局。",
    tags: ["初恋", "久别重逢", "冬日"],
  },
  {
    id: "seventh-suspect",
    title: "第七个嫌疑人",
    originalTitle: "The Seventh Suspect",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20movie%20poster%20art%2C%20six%20blurred%20silhouettes%20and%20one%20lit%20figure%20in%20a%20dark%20interrogation%20room%2C%20harsh%20overhead%20light%2C%20cold%20grey%20with%20amber%20accent%2C%20tense%20mood&width=600&height=900&seq=yp-poster-18&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20interrogation%20room%20with%20a%20long%20table%2C%20harsh%20overhead%20light%2C%20dark%20shadows%2C%20cold%20grey%20palette%20with%20amber%20accent%2C%20tense%20mystery%20film%20still&width=1600&height=900&seq=yp-cover-18&orientation=landscape",
    year: 2026,
    rating: 8.6,
    genres: ["thriller"],
    director: "陆慎",
    cast: ["韩雪落", "江铭", "周语"]
    ,
    duration: 126,
    releaseDate: "2026-04-18",
    region: "中国大陆",
    heat: 8880,
    summary: "密室里七个人，六个说谎，只有一个在讲真话——但没人知道是谁。",
    synopsis:
      "一场突如其来的暴雪，把七名陌生人困在山间别墅。当晚，主人被发现死于上锁的书房。每个人都藏着秘密，每个人都有可能说谎。侦探必须在雪停之前，找出那个唯一说真话的人。",
    tags: ["密室", "本格推理", "群像"],
  },
  {
    id: "hunt-shadow",
    title: "猎影追凶",
    originalTitle: "Hunting the Shadow",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20thriller%20movie%20poster%20art%2C%20a%20runner%20sprinting%20across%20rooftops%20at%20night%2C%20motion%20blur%20city%20lights%2C%20cool%20grey%20with%20warm%20amber%20streaks%2C%20high%20energy%20mood&width=600&height=900&seq=yp-poster-19&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=High%20octane%20cinematic%20rooftop%20chase%20scene%20at%20night%20over%20a%20glittering%20city%2C%20motion%20blur%20and%20light%20streaks%2C%20cool%20grey%20with%20warm%20amber%2C%20thrilling%20film%20still&width=1600&height=900&seq=yp-cover-19&orientation=landscape",
    year: 2026,
    rating: 8.1,
    genres: ["action", "thriller"],
    director: "岳峰",
    cast: ["秦烈", "关山月", "何塞·罗"]
    ,
    duration: 132,
    releaseDate: "2026-07-03",
    region: "中国大陆",
    heat: 8520,
    summary: "一名私家侦探追踪一名神秘失踪者，却发现自己才是被猎捕的对象。",
    synopsis:
      "私家侦探接下一起普通的寻人委托，却在调查中卷入跨国黑市的漩涡。线索指向一个代号“影子”的神秘人物。当他越发接近真相，越感到背后有一双眼睛在盯着自己——他追的凶，或许正是他自己。",
    tags: ["追凶", "都市", "高能"],
  },
  {
    id: "city-above-clouds",
    title: "云上之城",
    originalTitle: "The City Above the Clouds",
    poster:
      "https://readdy.ai/api/search-image?query=Utopian%20cinematic%20sci%20fi%20movie%20poster%20art%2C%20a%20gleaming%20city%20floating%20on%20clouds%20with%20a%20solitary%20figure%20at%20its%20edge%2C%20clean%20bright%20futuristic%20design%2C%20soft%20golden%20and%20grey%20palette&width=600&height=900&seq=yp-poster-20&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20cinematic%20utopian%20city%20floating%20above%20a%20sea%20of%20clouds%20at%20sunrise%2C%20sleek%20futuristic%20architecture%2C%20warm%20golden%20light%2C%20awe%20inspiring%20scale%2C%20film%20still&width=1600&height=900&seq=yp-cover-20&orientation=landscape",
    year: 2025,
    rating: 8.2,
    genres: ["scifi", "drama"],
    director: "顾星河",
    cast: ["江叙白", "郑亦辰", "桑妮·洛"]
    ,
    duration: 136,
    releaseDate: "2025-09-05",
    region: "中国大陆",
    heat: 7080,
    summary: "在云端之上的理想国，一个底层工程师发现了维持天堂运转的秘密。",
    synopsis:
      "云上之城是人类最后的理想家园，人们在这里过着无忧无虑的生活。来自地表的维修工程师阿澈，在为城市检修能源核心时，意外发现了被精心隐藏的真相。理想国的代价，究竟由谁来偿付？",
    tags: ["乌托邦", "反乌托邦", "视觉奇观"],
  },
  {
    id: "small-town",
    title: "小城故事多",
    originalTitle: "Many Stories in a Small Town",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20slice%20of%20life%20movie%20poster%20art%2C%20a%20warm%20evening%20in%20a%20small%20town%20street%20with%20shopkeepers%20and%20neighbors%20chatting%2C%20soft%20warm%20light%2C%20nostalgic%20cozy%20mood%2C%20earthy%20tones&width=600&height=900&seq=yp-poster-21&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20cinematic%20panorama%20of%20a%20small%20town%20main%20street%20at%20golden%20evening%2C%20little%20shops%20and%20neighbors%2C%20soft%20nostalgic%20light%2C%20earthy%20warm%20palette%2C%20film%20still&width=1600&height=900&seq=yp-cover-21&orientation=landscape",
    year: 2026,
    rating: 7.7,
    genres: ["drama", "comedy"],
    director: "许蔚然",
    cast: ["陈默", "何蔓", "张致远"]
    ,
    duration: 108,
    releaseDate: "2026-02-27",
    region: "中国大陆",
    heat: 5640,
    summary: "一间老面馆，装着整条街的悲欢离合与烟火日常。",
    synopsis:
      "小城老街上有一家开了三十年的面馆，老板记得每一位熟客的口味，也听过他们的故事。有人来告别，有人来重逢，有人在深夜独自吃一碗热面。平凡烟火中，藏着最动人的人间温情。",
    tags: ["群像", "烟火气", "治愈"],
  },
  {
    id: "carnival",
    title: "全民狂欢",
    originalTitle: "Everyone's Carnival",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%2C%20a%20crowd%20of%20colorful%20characters%20celebrating%20in%20a%20festival%20street%2C%20confetti%20and%20balloons%2C%20bright%20vivid%20warm%20colors%2C%20joyful%20chaotic%20energy&width=600&height=900&seq=yp-poster-22&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20cinematic%20festival%20street%20parade%20with%20crowds%20confetti%20and%20lanterns%2C%20bright%20warm%20saturated%20colors%2C%20joyful%20chaotic%20celebration%2C%20comedy%20film%20still&width=1600&height=900&seq=yp-cover-22&orientation=landscape",
    year: 2025,
    rating: 7.5,
    genres: ["comedy"],
    director: "钱多多",
    cast: ["牛大伟", "吴姐", "李好笑"]
    ,
    duration: 100,
    releaseDate: "2025-11-14",
    region: "中国大陆",
    heat: 5320,
    summary: "一场全镇总动员的选秀大赛，把所有人的秘密都翻了出来。",
    synopsis:
      "为了争夺一笔丰厚的奖金，小镇居民纷纷报名参加选秀大赛。从广场舞大妈到退休教师，从修车师傅到网红主播，人人摩拳擦掌。比赛过程中，误会、笑料与真情感交织，最终改变了整个小镇。",
    tags: ["群像", "搞笑", "正能量"],
  },
  {
    id: "blue-whale",
    title: "蓝鲸之梦",
    originalTitle: "Dream of the Blue Whale",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20documentary%20poster%20art%2C%20a%20majestic%20blue%20whale%20gliding%20through%20deep%20sunlit%20ocean%2C%20god%20rays%2C%20serene%20awe%20inspiring%20mood%2C%20rich%20teal%20and%20warm%20gold%20palette&width=600&height=900&seq=yp-poster-23&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20cinematic%20underwater%20scene%20of%20a%20giant%20blue%20whale%20swimming%20through%20deep%20blue%20ocean%20with%20sunbeams%20from%20above%2C%20schools%20of%20fish%2C%20awe%20inspiring%20nature%20film%20still&width=1600&height=900&seq=yp-cover-23&orientation=landscape",
    year: 2026,
    rating: 9.0,
    genres: ["documentary", "animation"],
    director: "海蓝",
    cast: ["旁白·叶清"]
    ,
    duration: 96,
    releaseDate: "2026-06-08",
    region: "中国大陆",
    heat: 6180,
    summary: "跟随一头蓝鲸的洄游之旅，见证海洋最深处的壮美与脆弱。",
    synopsis:
      "摄制组历时三年，跨越三大洋，追踪一头名为“蓝”的蓝鲸。影片用震撼的水下影像与细腻的动画重建，讲述它从出生到成年的漫长旅程，也让观众看见人类活动对海洋生态留下的痕迹。",
    tags: ["自然", "海洋", "环保", "高口碑"],
  },
  {
    id: "mountain-sea-scroll",
    title: "山海绘卷",
    originalTitle: "Scroll of Mountains and Seas",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20fantasy%20movie%20poster%20art%2C%20a%20young%20hero%20standing%20before%20a%20giant%20mythical%20beast%20in%20a%20misty%20ancient%20landscape%2C%20ink%20wash%20style%20with%20warm%20gold%20accents%2C%20epic%20mythic%20mood&width=600&height=900&seq=yp-poster-24&orientation=portrait",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20animated%20fantasy%20panorama%20of%20ancient%20mythical%20landscape%20with%20floating%20mountains%20and%20a%20giant%20mythical%20creature%2C%20ink%20wash%20painting%20style%20with%20warm%20gold%20light%2C%20awe%20inspiring%20film%20still&width=1600&height=900&seq=yp-cover-24&orientation=landscape",
    year: 2026,
    rating: 8.7,
    genres: ["animation"],
    director: "墨白",
    cast: ["配音·林鹿", "配音·江铭", "配音·白鹿"]
    ,
    duration: 104,
    releaseDate: "2026-07-18",
    region: "中国大陆",
    heat: 9060,
    summary: "少年拾起一卷残破古画，踏入山海异兽并存的奇幻世界。",
    synopsis:
      "少女阿墨在祖父的旧书店里发现一卷会发光的古画。画中世界，山海异兽一一苏醒。为了修补这卷即将消散的绘卷，她与一只会说人话的小兽结伴而行，踏上一段寻找“绘卷之心”的奇幻冒险。",
    tags: ["国风", "神话", "全年龄"],
  },
];